<template>
  <div class="location-distance">
    <div class="location-distance__title">
      {{ $t('location.distance.title') }}
    </div>
    <vue-slider
      class="location-distance__slider"
      :value="currentDistance"
      tooltip="focus"
      :min="distanceArray[0]"
      :max="distanceArray[1]"
      :clickable="false"
      :dotSize="24"
      :interval="1"
      :enable-cross="false"
      :tooltip-formatter="`{value} ${distanceUnit}`"
      tooltipPlacement="bottom"
      :rail-style="{
        backgroundColor: '#ddd',
        height: '6px',
      }"
      :dot-style="{
        backgroundColor: '#54cad9',
        border: '2px solid #fff',
        boxShadow: 'none',
      }"
      :process-style="{ backgroundColor: '#54cad9' }"
      :tooltip-style="{
        backgroundColor: '#54cad9',
        borderColor: '#54cad9',
        fontSize: '0.75rem',
        fontWeight: 'bold',
        padding: '4px 8px',
      }"
      :marks="marksDistance"
      @dragging="update"
      @drag-end="refresh"
    ></vue-slider>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'

export default {
  name: 'LocationDistance',
  components: {
    VueSlider,
  },
  props: {
    distanceArray: {
      type: Array,
      required: true,
    },
    distanceUnit: {
      type: String,
      required: true,
    },
    currentDistance: {
      type: Number,
      required: true,
    },
  },
  created() {
    this.marksDistance = value => {
      if (value === this.distanceArray[0]) {
        return {
          label: `${value} ${this.distanceUnit}`,
          labelStyle: {
            fontSize: '0.75rem',
            marginTop: '0',
            padding: '12px 0 0',
          },
        }
      }
      if (value === this.distanceArray[1]) {
        return {
          label: `${value} ${this.distanceUnit}`,
          labelStyle: {
            fontSize: '0.75rem',
            marginTop: '0',
            padding: '12px 0 0',
          },
        }
      }
    }
  },
  methods: {
    update(value) {
      this.$emit('update', value)
    },
    refresh() {
      this.$emit('refresh')
    },
  },
}
</script>

<style lang="scss">
.location-distance {
  padding-bottom: 20px;

  &__title {
    @include sub-title;
  }

  &__slider {
    .vue-slider-mark {
      &:first-child .vue-slider-mark-label {
        left: 0;
        transform: translateX(0);
      }

      &:nth-child(2) .vue-slider-mark-label {
        transform: translateX(-100%);
        text-align: right;
      }
    }
  }
}
</style>
